import { render, staticRenderFns } from "./ConsumptionBarChart.vue?vue&type=template&id=54f2c452&scoped=true&"
import script from "./ConsumptionBarChart.vue?vue&type=script&lang=js&"
export * from "./ConsumptionBarChart.vue?vue&type=script&lang=js&"
import style0 from "./ConsumptionBarChart.vue?vue&type=style&index=0&id=54f2c452&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54f2c452",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VProgressCircular,VSpacer})
